
const smProjDndConfig = {

    projTyp: undefined,
    setProjTyp: function (projTyp) {
        this.projTyp = projTyp;
    },
    getProjTyp: function () {
        return this.projTyp;
    },
    isSAPrm: function (guid) {

        if (guid) {
            let guidArray = guid.split("_");
            return this.isSAPrmByAP(guidArray[0]);
        }
    },
    isSAPrmByAP: function (ap) {
        if (!ap) {
            return;
        }

        if (sgiSrvUrl.allOldParamFlag) {
            return false;
        }
        //"sd", "rtsd", "param", "rtuam", "workbench","gw", "knowledgeBase", "stats"
        let oldParamAPs = [];
        oldParamAPs.push(...(sgiSrvUrl.oldParamAPs || []));
        if (oldParamAPs.indexOf(ap) < 0) {
            return true;
        }
    },
    getPrmByTT: function (ap, tt) {
        if (this.projTyp === "sm") {
            return SAPrmFactory.getPrmDetailByTT(ap, tt);
        } else {
            return PrmFactory.getPrmByTT(ap, tt);
        }
    },

    getDSDSelectGuid() {
        if (this.projTyp === "sm") {
            // return "sd_UI_bruUI.dbase.sub_15018-08";
            return "sm_UI_du.sd_021501-06";
        } else {
            return "rtsd_UI_DSD_2001";
        }
    },

    getDSDPreviewSelectGuid() {
        if (this.projTyp === "sm") {
            // return "sd_UI_bruUI.dbase.sub_15018-06";
            return "sm_UI_du.sd_021601";
        } else {
            return "rtsd_UI_DSD_0005";
        }
    },

    // getDSDPreviewSelectGuid() {
    //     if (this.projTyp === "sm") {
    //         return "sd_UI_bruUI.dbase.sub_15018-09";
    //     } else {
    //         return "rtsd_UI_DSD_0005";
    //     }
    // },

    getPrm: function (item) {
        if (this.projTyp === "sm") {
            return SAPrmFactory.getPrm(item);
        } else {
            return PrmFactory.getPrm(item);
        }
    }

    // getDndDevMainCUIInsertInit: function (ap, tt) {
    //     if (this.projTyp === "sm") {
    //         return SAPrmFactory.getPrmDetailByTT(ap, tt) || [];
    //     } else {
    //         return PrmFactory.getPrmByTT(ap, tt) || [];
    //     }
    // }
}

export default smProjDndConfig;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiConfig/smProjDndConfig.js